/**
 *  Carousel
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';

import LinkImgDraggableDisplay from '@/src/components/LinkImgDraggableDisplay';
import AutoPlay from '@/src/constrains/SalesChannelPreviewPageComponents/AutoPlay';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { CarouselOptions } from '@/src/pages/SalesChannelContentEditor/common';
import { Select } from 'src/components/Antd';

import {
  EnumCarouselOptions,
  optionsToNum,
} from '@/src/pages/SalesChannelContentEditor/common';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Carousel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const _rHasError = React.useRef(true);
  const {
    droppableId,

    onItemDelete,
    onItemAdd,
    onItemChange,
    onItemSort,
    onStaticChange,
    //To Do Delete Link Temp
    linkSet,
    staticData,
    linkModules,
    specificError,
    disabled,
    hideEdit,
  } = props;

  const { posterType, autoPlay, intervalTime } = staticData;
  const handleItemOnAdd = (e) => {
    if (onItemAdd) {
      onItemAdd(posterType);
    }
  };

  const handleItemOnChange = (index, obj) => {
    if (onItemChange) {
      onItemChange(index, obj);
    }
  };

  const handleItemOnSort = (from, to) => {
    if (onItemSort) {
      onItemSort(from, to);
    }
  };

  const handleOnItemDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const handlePosterTypeOnChange = (e) => {
    if (onStaticChange) {
      onStaticChange({ posterType: e });
    }
  };

  const handleAutoPlayOnChange = (e) => {
    if (onStaticChange) {
      onStaticChange({ autoPlay: e });
    }
  };

  const handleIntervalOnChange = (e) => {
    if (onStaticChange) {
      onStaticChange({ intervalTime: e });
    }
  };

  const _tip = React.useMemo(() => {
    if (posterType) {
      if (posterType === EnumCarouselOptions.One) {
        return null;
      } else {
        const number = optionsToNum[posterType];
        return `${getI18n('general.carouselTipText')} ${number}`;
      }
    }
    return null;
  }, [posterType]);

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('general.type')} belowComponentTitle={_tip}>
          <Select
            size='large'
            optionsList={CarouselOptions}
            value={posterType}
            onChange={handlePosterTypeOnChange}
            disabled={disabled}
          />
        </ItemWrapper>
        <ItemWrapper>
          <AutoPlay
            interOnChange={handleIntervalOnChange}
            autoOnChange={handleAutoPlayOnChange}
            isAuto={autoPlay}
            interval={intervalTime}
            disabled={disabled}
          />
        </ItemWrapper>
      </Section>
      <LinkImgDraggableDisplay
        error={specificError}
        linkSet={linkSet}
        droppableId={droppableId || 'CarouselDropZone'}
        data={linkModules}
        addText={`+ ${getI18n('general.addImageLink')}`}
        onAdd={handleItemOnAdd}
        onChange={handleItemOnChange}
        onSort={handleItemOnSort}
        onDelete={handleOnItemDelete}
        disabled={disabled}
        hideEdit={hideEdit}
      />
    </React.Fragment>
  );
};
export default Carousel;
